import * as React from 'react';
import { useAppSelector } from '>root/store/main';
import {Redirect, RouteChildrenProps} from 'react-router-dom';

export function withAuthRequired(WrappedComponent: React.ComponentType<RouteChildrenProps>) {
  const ComponentRequiringAuthentication = (props: RouteChildrenProps) => {
    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

    return isAuthenticated ? (
      <WrappedComponent {...props} />
    ) : (
      <Redirect to={`/login?redirect_uri=${encodeURIComponent(window.location.href)}`} />
    );
  };

  return ComponentRequiringAuthentication;
}
